export enum ESubscriptionStatus {
  DRAFT = "DRAFT",
  IN_REVIEW = "IN_REVIEW",
  ACTIVE = "ACTIVE",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED"
}
